export enum NavigationProgressStepsEnum {
  StepOne = 'Step 1: ',
  StepTwo = 'Step 2: ',
  StepThree = 'Step 3: ',
}
